import { cx } from '@emotion/css';
import { Menu as MUIMenu } from '@mui/material';
import React, { useCallback, useState, memo, useRef } from 'react';
import { ix } from '../../../../utils/ix';
import { Button } from '../../../atoms/Button';
import { useStyles } from './BaseFilterMenu.styles';
export const BaseFilterMenu = memo(function BaseFilterMenu(props) {
    const { onChipClick, onClose } = props;
    const anchorElementRef = useRef(null);
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const isMenuOpenControlledByProps = props.open !== undefined;
    const menuId = ix(props.id, 'menu');
    const open = isMenuOpenControlledByProps ? Boolean(props.open) : Boolean(anchorEl);
    const handleChipClick = useCallback((event) => {
        setAnchorEl(event.currentTarget);
        if (onChipClick) {
            onChipClick(event);
        }
    }, [onChipClick]);
    const handleClose = useCallback(() => {
        setAnchorEl(null);
        if (onClose) {
            onClose();
        }
    }, [onClose]);
    return (React.createElement("div", { className: cx(props.className, classes.root), id: props.id },
        React.createElement("div", { ref: anchorElementRef },
            React.createElement(Button, { "aria-controls": menuId, "aria-haspopup": "true", className: cx(classes.chip, { [classes.activeChip]: open }), id: ix(props.id, 'chip'), onClick: handleChipClick, size: props.size },
                React.createElement("div", { className: classes.chipContent, id: ix(props.id, 'chip-content') }, props.chipContent))),
        React.createElement(MUIMenu, { classes: { paper: classes.menuPaper }, id: menuId, anchorEl: isMenuOpenControlledByProps ? anchorElementRef.current : anchorEl, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            }, keepMounted: true, open: open, onClose: handleClose },
            React.createElement("div", { className: classes.menuContent, id: ix(props.id, 'menu-content') }, props.menuContent))));
});
//# sourceMappingURL=BaseFilterMenu.js.map